import styled, { css } from 'styled-components';

import Offer from 'components/offer';

export const OffersList = styled.div`
  display: flex;
  padding: 0 0.5rem;
  flex-wrap: wrap;
  justify-content: center;

  max-width: ${Styles.layout.sectionMaxWidth};
  margin: 0 auto;

  ${Styles.desktop`
    padding: 0 0.25rem;
  `}
`;

const offerStyles = css`
  margin: 0.5rem;
  width: calc(100vw - 1rem);
  max-width: 475px;

  @media screen and (min-width: 366px) {
    max-width: 350px;
    width: 100%;
  }

  ${Styles.desktop`
    width: calc((100% - 3rem) / 3);
  `}
`;

export const OfferPlaceholder = styled.div`
  ${offerStyles}
`;

export const StyledOffer = styled<typeof Offer>(Offer)`
  ${offerStyles}
`;

export const RefreshOffersButton = styled.div`
  display: none;
`;

export const StyledRefreshIcon = styled.div`
  display: none;
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 18rem;
  width: 100%;
`;

export const Wrap = styled.div`
  padding: 40px 0;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;

  ${Styles.desktop`
    padding-top: 10vw;
    padding-bottom: 10vw;
  `}
`;
